import styled, { keyframes, css } from 'styled-components'
import { isMobileStyleMixin, TextButton } from '@amzn/storm-ui'

export const fadeOutFrames = keyframes`
0% {
  opacity: 1;
}
100% {
  opacity: 0;
}
`

export const fadeInFrames = keyframes`
0% {
  opacity: 0;
}
100% {
  opacity: 1;
}
`

export const fadeIn = css`
  animation: ${fadeInFrames} 500ms;
`
export const fadeOut = css`
  animation: ${fadeOutFrames} 500ms;
`

export const ArrowButton = styled(TextButton)`
  color: ${({ theme }) => theme.palette.white};
  width: 36px;
  height: 36px;
  ${isMobileStyleMixin(css`
    width: 24px;
    height: 24px;
  `)}
  align-self: center;

  &:hover {
    color: ${({ theme }) => theme.palette.white};
  }

  &:focus {
    outline: 2px solid #fff;
  }
`

export const DesktopPreviousButtonContainer = styled(ArrowButton)`
  top: 50%;
  margin: 0 8px 0 30px;
`

export const DesktopNextButtonContainer = styled(ArrowButton)`
  top: 50%;
  margin: 0 30px 0 8px;
`

export const MobilePreviousButtonContainer = styled(ArrowButton)`
  margin: 0 10px 0 12px;
`

export const MobileNextButtonContainer = styled(ArrowButton)`
  margin: 0 12px 0 10px;
`
